import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirmCopy",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100 fs-9" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "text-center border-bottom mb-4" }
const _hoisted_9 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_10 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_11 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_12 = {
  class: "modal fade",
  id: "modalCopySuccess",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "modal-dialog modal-lg" }
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = { class: "modal-header" }
const _hoisted_16 = { class: "modal-title fw-bold text-center w-100 fs-9" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_18 = { class: "modal-body" }
const _hoisted_19 = { class: "text-center border-bottom mb-4" }
const _hoisted_20 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_21 = { class: "col-lg-6 d-flex justify-content-center mb-4 mb-lg-0" }

import { onMounted, ref } from 'vue'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  sourceLabel: {
    type: String,
    default: '',
  },
},
  emits: ['copy'],
  setup(__props, { expose, emit }) {



const modalConfirmCopy = ref()
const modalCopySuccess = ref()
const loading = ref(false)

onMounted(() => {
  modalConfirmCopy.value = new Modal(document.getElementById('modalConfirmCopy'))
  modalCopySuccess.value = new Modal(document.getElementById('modalCopySuccess'))
})



expose({
  showConfirmModal: (): void => modalConfirmCopy.value.show(),
})

const handleCopy = () => {
  loading.value = true
  emit('copy')
  loading.value = false
  modalConfirmCopy.value.hide()
  modalCopySuccess.value.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('CG40titlecopyconfirm')), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(__props.sourceLabel) + _toDisplayString(_unref(translate)('CG40copyfromhere')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(translate)('CG40notechangeswilldiscarded')), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(Button, {
                  title: _unref(translate)('back'),
                  type: 'secondary',
                  className: 'fw-bold',
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(Button, {
                  title: _unref(translate)('CG40handlecopy'),
                  type: 'secondary',
                  className: 'fw-bold',
                  onClick: handleCopy,
                  loading: loading.value,
                  disabled: loading.value
                }, null, 8, ["title", "loading", "disabled"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h5", _hoisted_16, _toDisplayString(_unref(translate)('CG40titlecopysuccess')), 1),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", null, _toDisplayString(_unref(translate)('CG40copied')), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(Button, {
                  title: _unref(translate)('close'),
                  type: 'secondary',
                  className: 'fw-bold',
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})